import React from "react";
// import { ChevronRightIcon } from "@heroicons/react/20/solid"; // Example icon from Heroicons

const ImageText2 = ({
  imageUrl,
  heading,
  text,
  buttonText,
  buttonLink,
  leftColor = "#ffffff", // Default left color
  rightColor = "#ffffff", // Default right color
  textColor = "#000000",
  logoUrl,
  borderWidth = "0px",
  borderColor = "transparent",
}) => {
  return (
    <div className="bg-black py-12">
      <div
        className="mx-auto py-12 px-4 sm:px-6 lg:px-8 rounded-md"
        style={{
          maxWidth: "1152px",
          background: `linear-gradient(to right, ${leftColor}, ${rightColor})`,
          border: `${borderWidth} solid ${borderColor}`,
        }}
      >
        <div className="flex flex-col lg:flex-row items-center space-y-6 lg:space-y-0 lg:space-x-12">
          <div className="w-full lg:w-2/3">
            <h2
              className="text-2xl lg:text-2xl font-semibold mb-4"
              style={{ color: textColor, fontWeight: "bold" }}
            >
              {heading}
            </h2>
            <p className="text-lg lg:text-lg" style={{ color: textColor }}>
              {text}
            </p>
            {buttonText && (
              <a
                href={buttonLink}
                className="relative no-underline inline-flex items-center justify-center px-8 py-2.5 overflow-hidden tracking-tighter text-white bg-orange-500 rounded-md group"
              >
                <span className="absolute w-0 h-0 transition-all duration-500 ease-out bg-black rounded-full group-hover:w-56 group-hover:h-56"></span>
                <span className="absolute bottom-0 left-0 h-full -ml-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-auto h-full opacity-100 object-stretch"
                    viewBox="0 0 487 487"
                  >
                    <path
                      fillOpacity=".1"
                      fillRule="nonzero"
                      fill="#FFF"
                      d="M0 .3c67 2.1 134.1 4.3 186.3 37 52.2 32.7 89.6 95.8 112.8 150.6 23.2 54.8 32.3 101.4 61.2 149.9 28.9 48.4 77.7 98.8 126.4 149.2H0V.3z"
                    ></path>
                  </svg>
                </span>
                <span className="absolute top-0 right-0 w-12 h-full -mr-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="object-cover w-full h-full"
                    viewBox="0 0 487 487"
                  >
                    <path
                      fillOpacity=".1"
                      fillRule="nonzero"
                      fill="#FFF"
                      d="M487 486.7c-66.1-3.6-132.3-7.3-186.3-37s-95.9-85.3-126.2-137.2c-30.4-51.8-49.3-99.9-76.5-151.4C70.9 109.6 35.6 54.8.3 0H487v486.7z"
                    ></path>
                  </svg>
                </span>
                <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-gray-200"></span>
                <span className="relative text-base font-semibold">
                  {buttonText}
                </span>
              </a>
            )}
            {logoUrl && (
              <div className="mt-4">
                <img src={logoUrl} alt="logo" className="w-[360px] h-auto" />
              </div>
            )}
          </div>
          <div className="w-full lg:w-auto">
            <img src={imageUrl} alt="placeholder" className="w-full h-auto" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImageText2;
